import { useRef } from 'react';
import { Controller } from 'react-hook-form';

export const OTPInput = ({
  control,
  name = 'otp',
  length = 4,
  onAutoSubmit,
  verified,
}) => {
  const inputRefs = useRef([]);

  return (
    <Controller
      control={control}
      name={name}
      defaultValue=""
      rules={{
        required: 'OTP is required',
        validate: (val) =>
          val.length === length || `OTP must be ${length} digits`,
      }}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        const handleChange = (e, index) => {
          const val = e.target.value;
          if (!/^\d?$/.test(val)) return;

          const otpArray = value.split('');
          otpArray[index] = val;
          const newOtp = otpArray.join('').padEnd(length, '');
          onChange(newOtp);

          if (val && index < length - 1) {
            inputRefs.current[index + 1]?.focus();
          }

          //  Detect when user finishes typing the last digit
          if (val && index === length - 1) {
            if (onAutoSubmit) {
              setTimeout(() => onAutoSubmit(), 150);
            }
          }
        };

        const handleKeyDown = (e, index) => {
          if (e.key === 'Backspace' && !value[index] && index > 0) {
            inputRefs.current[index - 1]?.focus();
          }
        };

        return (
          <div className="flex flex-col items-center gap-2">
            <div className="flex gap-2 justify-center">
              {[...Array(length)].map((_, i) => (
                <input
                  key={i}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  className="w-[54px] h-[55px] text-center font-bold text-2xl border border-[#DBDBDB] rounded-[6px] focus:outline-none focus:ring-2 focus:ring-[#F05929]"
                  value={value[i] || ''}
                  onChange={(e) => handleChange(e, i)}
                  onKeyDown={(e) => handleKeyDown(e, i)}
                  ref={(el) => (inputRefs.current[i] = el)}
                  disabled={verified}
                />
              ))}
            </div>
            {error && (
              <p className="text-sm text-red-500 mt-1 text-center">
                {error.message}
              </p>
            )}
          </div>
        );
      }}
    />
  );
};
